import { gsap, ScrollTrigger } from "@gsap";

const token = (name) => getComputedStyle(document.documentElement).getPropertyValue(`--pk-stats-count-${name}`).trim().replace(/^["']|["']$/g, "");

function parse(text) {
	const match = text.match(/^(\D*)([\d.,]+)(.*)$/);
	if (!match) return null;
	const [, prefix, raw, suffix] = match;
	const decimals = raw.includes(",") ? raw.split(",")[1].length : 0;
	const value = parseFloat(raw.replace(/\./g, "").replace(",", "."));
	return Number.isNaN(value) ? null : { prefix, suffix, value, decimals, grouped: raw.includes(".") };
}

function format(number, { prefix, suffix, decimals, grouped }) {
	const formatted = number.toLocaleString("nl-NL", {
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals,
		useGrouping: grouped,
	});
	return `${prefix}${formatted}${suffix}`;
}

function initStats() {
	document.querySelectorAll(".stats-layout").forEach((layout) => {
		const numbers = layout.querySelectorAll("[data-count]");
		if (!numbers.length) return;

		gsap.matchMedia().add("(prefers-reduced-motion: no-preference)", () => {
			const restore = [];

			numbers.forEach((el) => {
				const config = parse(el.textContent.trim());
				if (!config) return;

				const counter = { value: 0 };
				el.textContent = format(0, config);

				gsap.to(counter, {
					value: config.value,
					duration: parseFloat(token("duration")) || 2,
					ease: token("ease") || "power2.out",
					onUpdate: () => (el.textContent = format(counter.value, config)),
					scrollTrigger: { trigger: el, start: "top 90%", once: true },
				});

				restore.push(() => (el.textContent = format(config.value, config)));
			});

			return () => restore.forEach((fn) => fn());
		});
	});
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initStats);
} else {
	initStats();
}
